export enum UserForegroundDomainEnum {
  Informal = 'informal',
  Formal = 'formal',
}
